import { Icon } from '@iconify/react';
import { Button } from '@nextui-org/react';
import Markdown from 'react-markdown';
import { Post } from '../../../types/agent';

interface GeneratedResponseProps {
  isRunLoading: boolean;
  generatedResponse: string;
  addingToConversation: boolean;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  promptData: any; // Consider adding proper type
  posts: Post[];
  setPosts: (posts: Post[]) => void;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  addToConversationMutation: (payload: any) => void; // Consider adding proper type
}

export default function GeneratedResponse({
  isRunLoading,
  generatedResponse,
  addingToConversation,
  promptData,
  posts,
  setPosts,
  addToConversationMutation,
}: GeneratedResponseProps) {
  const latestUserMessage = promptData
    ? `latestUserMessage_${promptData.id}`
    : null;
  const lastUserMessage =
    posts.length > 0
      ? posts.filter((post) => post.text_src === 'User').pop()?.text ||
        latestUserMessage
      : latestUserMessage;

  return (
    <div className="w-full p-4 bg-default-50 relative">
      <div className="space-y-4">
        <div className="flex items-center justify-between">
          <h3 className="text-lg font-medium">Generated Response</h3>
        </div>
        <div className="whitespace-pre-wrap text-default-600 max-h-[calc(100vh-12rem)] overflow-y-auto">
          {isRunLoading ? (
            <div className="text-default-400 text-center py-8">
              <Icon
                icon="material-symbols:progress-activity"
                className="w-8 h-8 animate-spin mx-auto mb-2"
              />
              Generating response...
            </div>
          ) : generatedResponse ? (
            <div className="text-sm">
              <Markdown>{generatedResponse}</Markdown>
            </div>
          ) : (
            <div className="text-default-400 text-center py-8">
              Click Run to generate a response
            </div>
          )}
        </div>
      </div>

      {generatedResponse && (
        <Button
          color="primary"
          className="fixed bottom-8 right-8"
          onPress={() => {
            const newPosts = [
              { text_src: 'Assistant', text: generatedResponse },
              { text_src: 'User', text: '' },
            ];
            setPosts([...posts, ...newPosts]);
            addToConversationMutation({
              posts: [
                {
                  conversation_id: promptData?.id,
                  text: lastUserMessage,
                  text_src: 'User',
                },
                {
                  conversation_id: promptData?.id,
                  text: generatedResponse,
                  text_src: 'Assistant',
                },
              ],
            });
            localStorage.removeItem('latestUserMessage');
          }}
          isLoading={addingToConversation}
        >
          Add to Conversation
        </Button>
      )}
    </div>
  );
}
